import fetch from "../../auth/FetchInterceptor";

export const getTags = function () {
  return fetch({
    url: '/tags',
    method: 'get',
  })
}

export const getTag = (tagId) => {
  return fetch({
    url: `/tags/${tagId}`,
    method: 'GET',
  });
}

export const createTag = (data) => {
  return fetch({
    url: `/tags`,
    method: 'POST',
    data,
  });
}

export const updateTag = (tagId, data) => {
  return fetch({
    url: `/tags/${tagId}`,
    method: 'PUT',
    data,
  });
}

export const deleteTag = (tagId) => {
  return fetch({
    url: `/tags/${tagId}`,
    method: 'DELETE',
  });
}